export default function flattenTree(nodes, subTreeKey, result = []) {
  if (!Array.isArray(nodes)) {
    return []
  }

  for (const node of nodes) {
    result.push(node)

    if (node.hasOwnProperty(subTreeKey)) {
      flattenTree(node[subTreeKey], subTreeKey, result)
    }
  }

  return result
}
